module.exports = __webpack_public_path__ + "static/media/featuressection4.74e81b58.png";